import React from "react";
import * as XLSX from "xlsx";
import ImportadorExcelGenerico from "../../../../../Components/ImportadorExcelGenerico";

const columnasPreview = [
  {
    title: "Nombre",
    dataIndex: "nombre",
    key: "nombre",
    width: 280,
  },
];

const construirPlantilla = (catalogos) => {
  const wb = XLSX.utils.book_new();

  const ejemplos = [
    { Nombre: "Bachillerato General" },
    { Nombre: "Ingeniería en Sistemas" },
  ];
  const hojaPrincipal = XLSX.utils.json_to_sheet(ejemplos, {
    header: ["Nombre"],
  });
  hojaPrincipal["!cols"] = [{ wch: 32 }];
  XLSX.utils.book_append_sheet(wb, hojaPrincipal, "Programas Educativos");

  const existentes = (catalogos.programas || []).map((p) => ({
    Nombre: p.nombre,
    Estado: p.estado === 1 ? "Activo" : "Deshabilitado",
  }));
  const hojaExistentes =
    existentes.length > 0
      ? XLSX.utils.json_to_sheet(existentes)
      : XLSX.utils.json_to_sheet([{ Nombre: "(no hay programas registrados)" }]);
  hojaExistentes["!cols"] = [{ wch: 32 }, { wch: 16 }];
  XLSX.utils.book_append_sheet(wb, hojaExistentes, "Existentes");

  return wb;
};

const validarFila = (fila, catalogos, _indice, contexto) => {
  const errores = [];
  const nombre = fila["Nombre"] ? String(fila["Nombre"]).trim() : "";

  if (!nombre) {
    errores.push({ campo: "Nombre", motivo: "está vacío" });
    return { ok: false, errores };
  }

  const llave = nombre.toLowerCase();

  const existeYa = (catalogos.programas || []).some(
    (p) => (p.nombre || "").trim().toLowerCase() === llave,
  );
  if (existeYa) {
    errores.push({
      campo: "Nombre",
      motivo: "ya existe un programa educativo con ese nombre",
    });
  }

  if (contexto.clavesYaUsadas.has(llave)) {
    errores.push({
      campo: "Nombre",
      motivo: `nombre repetido en el archivo (también está en la fila ${contexto.clavesYaUsadas.get(llave)})`,
    });
  } else {
    contexto.clavesYaUsadas.set(llave, (fila["__rowNum__"] ?? 0) + 1);
  }

  if (errores.length > 0) {
    return { ok: false, errores };
  }

  return {
    ok: true,
    datos: { nombre },
  };
};

const ImportarProgramasEducativos = (props) => (
  <ImportadorExcelGenerico
    {...props}
    titulo="Importar Programas Educativos"
    nombreEntidadPlural="programas educativos"
    endpointDatosImportar="programasEducativos/datosParaImportarProgramasEducativos"
    endpointImportar="programasEducativos/importarProgramasEducativos"
    nombrePlantilla="plantillaProgramasEducativos.xlsx"
    construirPlantilla={construirPlantilla}
    validarFila={validarFila}
    columnasPreview={columnasPreview}
  />
);

export default ImportarProgramasEducativos;
